import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ModalWizard from "../../../components/modal/ModalWizard";
import RouteCreator from "../../../core/RouteCreator";
import StockService from "../../../services/Stock/StockService";
import TagsService from "../../../services/Tags/TagsService";
import CollectCylinderWizard from "./components/CollectCylinderWizard";

const ScreeWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    display: flex;
    flex-wrap: nowrap;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
`;

const CollectCylinder = () => {
    const { t } = useTranslation("screens");
    const history = useHistory();

    const queryCylinderTags = async (tag) => {
        if (tag.length > 2) {
            const tags = await TagsService.lookupEmptyCylinderTags(tag);
            return tags.map((t) => t.id);
        }
        return [];
    };

    useEffect(() => {
        ModalWizard.show(
            CollectCylinderWizard(t, queryCylinderTags),
            {
                onSubmit: async (values) => {
                    const result = await StockService.collectEmptyCylinder(
                        values.cylinderTagId
                    );
                    if (result && result.error)
                        ModalWizard.submitFailed(t(result.error.message));
                    else {
                        toast.success(
                            t("actions:dialogs.collectEmpty.success")
                        );
                        ModalWizard.hide();
                        setTimeout(() => {
                            history.push(RouteCreator.pwa.cylinders());
                        }, 100);
                    }
                },
                onCancel: async () => {
                    ModalWizard.hidePrompt(()=>history.goBack());
                },
            },
            { pwa: true }
        );
    }, []);

    return <ScreeWrapper></ScreeWrapper>;
};

export default CollectCylinder;
